export default {
  access_token: state => state.user.access_token,
  refresh_token: state => state.user.refresh_token,
  user_info: state => state.user.user_info,
  certification: state => state.certification
  // userInfo: state => state.user.user_info,


}
